export default "__VITE_ASSET__d45cb69d__"